import { Id, PagedSingleSelectField, laravelServiceSelectFetchConfig, withOptionsEndpoint } from "@dgs/core";
import { FC } from "react";

const service = withOptionsEndpoint<{ id: Id; name: string }>(["regions"]);
const fetchConfig = laravelServiceSelectFetchConfig(service);

interface Props {
	name: string;
	label: string;
	required?: boolean;
}

export const RegionSelectField: FC<Props> = (props) => {
	return <PagedSingleSelectField {...props} fetchConfig={fetchConfig} />;
};
